import { useState } from "react"
import { makeStyles } from "tss-react/mui"
import { Box, Menu, MenuItem, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus, faCheck } from "@fortawesome/pro-solid-svg-icons"
import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { ResourceFilterElement, ResourceFiltersSelectedItem } from "../../../createOrderTypes"
import { StandardButton } from "../../../../buttons/StandardButton"
import { FilterIcon } from "./FilterIcon"

const useStyles = makeStyles()((theme) => ({
    button: {
        color: theme.palette.tailwind.slate[950],
        padding: ".5rem 1rem",
    },
    menuItemWrap: {
        display: "grid",
        gridTemplateColumns: "1fr 1rem",
        width: "100%",
        gap: "1rem",
        alignItems: "center",
        color: theme.palette.tailwind.slate[950],
    },
    menuItem: {
        display: "grid",
        gridTemplateColumns: "1rem 1fr",
        gap: ".75rem",
        alignItems: "center",
    },
}))

type AddFiltersButtonProps = Readonly<{
    filters: ResourceFiltersSelectedItem[]
    resourceFiltersResult: ResourceFilterElement[]
    onAddFilter: (filter: string) => void
}>

export function AddFiltersButton({ filters, resourceFiltersResult, onAddFilter }: AddFiltersButtonProps) {
    const { classes } = useStyles()

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

    const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleCloseMenu = () => {
        setAnchorEl(null)
    }

    const handleAddFilter = (filter: string) => {
        onAddFilter(filter)
        handleCloseMenu()
    }

    return (
        <>
            <LocalizedStrict id="create-order-add-filters-button">
                <StandardButton
                    color="grey"
                    fullWidth={false}
                    variant="outlined"
                    size="small"
                    updateDefaultClasses={classes.button}
                    startIcon={<FontAwesomeIcon icon={faPlus} />}
                    onClick={handleOpenMenu}
                >
                    Add filters
                </StandardButton>
            </LocalizedStrict>
            <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={handleCloseMenu}>
                {resourceFiltersResult.map((filter) => (
                    <MenuItem key={filter.identifier} onClick={() => handleAddFilter(filter.identifier)}>
                        <Box className={classes.menuItemWrap}>
                            <Box className={classes.menuItem}>
                                <Box textAlign="center">
                                    <FilterIcon filterType={filter.identifier} />
                                </Box>
                                <Typography variant="body1">{filter.name}</Typography>
                            </Box>
                            {filters.some((f) => f.identifier === filter.identifier) && (
                                <FontAwesomeIcon icon={faCheck} />
                            )}
                        </Box>
                    </MenuItem>
                ))}
            </Menu>
        </>
    )
}
